<template>
  <td>
    <h6 class="custom-margin-h6-table">
      <strong>{{ tdLabel }}</strong>
    </h6>
    <template v-if="data">
      <el-tag
        v-for="(item, index) in data"
        :key="index"
        :effect="effect"
        :type="`${item.deleted_at ? `danger` : `info`}`"
      >
        {{ fieldTag === 'option' ? item : item[fieldTag] }}
      </el-tag>
      <el-tag v-if="data.length == 0" type="warning" :effect="effect">{{
        $t('common_words.no_assignment')
      }}</el-tag>
    </template>
  </td>
</template>
<script>
export default {
  name: 'td-info-tag',
  props: {
    data: {
      type: Array | undefined,
      required: true,
    },
    tdLabel: {
      type: String,
      required: true,
    },
    fieldTag: {
      type: String,
      required: true,
    },
    effect: {
      type: String,
      default: 'plain',
    },
  },
};
</script>
